module.exports = __webpack_public_path__ + "img/title.135c0e09.png";